export default __webpack_public_path__ + "static/media/skillsclub.c2d2040f.png";